module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dolores Hitchens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dolores Hitchens (1907–1973) was a highly prolific mystery author who wrote under multiple pseudonyms and in a range of styles. A large number of her books were published under the moniker D. B. Olsen, and a few under the pseudonyms Noel Burke and Dolan Birkley, but she is perhaps best remembered today for her later novel, "), _c('I', [_vm._v("Fool’s Gold")]), _vm._v(", published under her own name, which was adapted into the film "), _c('I', [_vm._v("Bande á part ")]), _vm._v("directed by Jean-Luc Godard.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xgRTdO/tc-custom/9781504084635.jpg?1729379878335",
      "alt": "This image is the cover for the book Something About Midnight, The Prof. A. Pennyfeather Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Something About Midnight, The Prof. A. Pennyfeather Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A sleuthing English professor looks into the sordid secret life of a student who’s gone missing . . .")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When a young woman comes to Professor Pennyfeather and confides that her cousin Ernestine—one of his English students—is missing, he’s surprised to hear that the bookish girl in his class is a very different person outside of school. Apparently, in the evenings, she transforms herself into a femme fatale and looks for naïve young sailors at the waterfront dancehalls, enjoying fancy nights out at their expense before verbally abusing and abandoning them. Now she hasn’t been seen in two days, and her cousin fears she’s taken one too many risks. The professor decides it’s time to do some research. He wants to know what happened to Ernestine, and what caused the orphaned heiress to pursue this secret life—one that just may have led to her death . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0